import styled, { css } from 'styled-components';
import { hideScroll } from 'styled-manila';
import { getColor, StyleVars } from 'core/utils/Styles';
import Heading from 'core/components/Heading';
import LazyLoadedImg from 'core/components/LazyLoadedImg';

export const horizontalOverflowParent = css`
	display: flex;
	flex-wrap: nowrap;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
	margin-left: -12px;
	margin-right: -12px;
	${hideScroll};
	scrollbar-width: none;

	@media(max-width: ${StyleVars.screenMd}) {
		margin-left: -16px;
		margin-right: -16px;
		padding-left: 25px;
	}
`;

export const horizontalOverflowItem = css`
	display: flex;
	flex-direction: column;
	text-decoration: none;
	padding: 0 12px;
	margin-bottom: 0;
	width: 33%;
	flex-basis: 33%;
	max-width: 33%;
	min-width: 33%;

	@media(max-width: ${StyleVars.screenMd}) {
		width: 267px;
		flex-basis: 267px;
		max-width: 267px;
		min-width: 267px;

		/* Show the last gap to the right */
		&:last-child {
			position: relative;

			&:after {
				content: '';
				width: 32px;
				height: 100%;
				display: block;
				position: absolute;
				top: 0;
				right: -32px;
			}
		}

	}
`;

export const Wrapper = styled.section`
	padding: 16px 0;
`;

export const PastBoxHeading = styled(Heading)`
	margin: 0;
`;

export const Boxes = styled.div`
	${horizontalOverflowParent}
	padding-top: 16px;
	padding-bottom: 16px;
	padding-left: 16px;
`;

export const Box = styled.a`
	${horizontalOverflowItem}
	cursor: pointer;
	figure {
		border-radius: 8px;
	}
`;

export const Frame = styled.div`
	overflow: hidden;
	position: relative;
	padding-top: 100%;
	margin-bottom: 17px;
	background-color: ${getColor('alto')};
	border-radius: 8px;
`;

export const PastBoxImage = styled(LazyLoadedImg)`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

export const Title = styled.h4`
	color: ${getColor("gray")};
	margin-bottom: 5px;
	font-size: 16px;
	line-height: 17px;
	letter-spacing: 0.2px;
	font-weight: 600;
`;

export const Description = styled.p`
	color: ${getColor('dustyGray')};
	font-size: 14px;
	line-height: 18px;
	letter-spacing: 0.2px;
`;

export const BoxesWrapper = styled.div`
	overflow: hidden;
	position: relative;
	width: 100%;
	margin-top: 24px;

	@media(max-width: ${StyleVars.screenMd}) {
		width: 100vw;
		margin-left: -12px;
	}

	${props => props.fadeOut && css`
		&:before {
			content: '';
			width: 120px;
			height: 100%;
			top: 0;
			right: 0;
			position: absolute;
			z-index: 1;
			background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.01), rgba(255, 255, 255, 1));

			@media (max-width: 767px) {
				width: 60px;
			}
		}
	`}

	${props => props.fadeIn && css`
		&:after {
			content: '';
			width: 120px;
			height: 100%;
			top: 0;
			left: 0;
			position: absolute;
			z-index: 1;
			background-image: linear-gradient(90deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.01));

			@media (max-width: 767px) {
				width: 60px;
			}
		}
	`}
`;
